import type { DetailSource } from "../types";

/**
 * Decide which citation-viewer backend can render a document's blocks, from
 * its ID prefix (authoritative) or the search source it came from. Returns
 * null when no block viewer exists: proteins open the dedicated
 * ProteinDetailPanel instead, and peer reviews stay CLI-only.
 */
export const detailSourceFor = (
  docId: string,
  searchSource?: string,
): DetailSource | null => {
  const id = docId.toLowerCase();
  if (id.startsWith("fda_")) return "fda";
  if (id.startsWith("tri_") || /^nct\d/.test(id)) return "clinicaltrials";
  switch (searchSource) {
    case "fda":
      return "fda";
    case "trials":
      return "clinicaltrials";
    case "patents":
      return "patents";
    case "proteins":
    case "peer_reviews":
      return null;
    default:
      return "papers";
  }
};
